import { useToast } from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import type { CreateWishlistInput } from "~graphql/generated/graphql"
import {
    namedOperations,
    useCreateWishlistMutation,
} from "~graphql/generated/graphql"

export function useCreateWishlist({
    onCompleted,
}: {
    onCompleted?: () => void
}) {
    const { showError, showSuccess } = useToast()

    const [createWishlistMutation, { loading: isLoading, error }] =
        useCreateWishlistMutation({
            onError: showError,
            onCompleted: () => {
                showSuccess(COPY.CREATED_WISHLIST)
                onCompleted?.()
            },
            refetchQueries: [namedOperations.Query.wishlistsByUser],
            awaitRefetchQueries: true,
        })

    const createWishlist = ({ data }: { data: CreateWishlistInput }) =>
        createWishlistMutation({
            variables: {
                data,
            },
        })

    return { createWishlist, isLoading, error }
}
